import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid} from '@material-ui/core'
import Utils from '../../providers/Utils';
import LocalStorage from '../../providers/LocalStorage';



 

export default class ConcediuDialog extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
     
         }
    }

     componentDidMount(){
  
    }

    

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="pm-alert-dialog"
                disableEscapeKeyDown
                fullWidth={true}
                maxWidth='sm'
                 open={this.props.open}
                 onClose={this.props.dialogClose}>
                 <DialogActions >
                 <Fab  onClick={this.props.dialogClose} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text-dialog'>close</i>
                            </Fab>
                 </DialogActions>
                 <h2 style={{marginBottom:0}} className='pm-title'>{this.props.title}</h2>
                 { this.props.aprobat !== null &&
                   <h4 style={{color:'green', textAlign:'center', marginTop:0}}>(Aprobat)</h4>

                 }

                    <h3 style={{color:this.props.tipConcediu.bkColor, margin:'auto'}}>{this.props.tipConcediu.nume}</h3>

        
                    <Grid  container  className="container pm-dialog-textfield-container" >
      
               
                            <Grid style={{textAlign:'center'}} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    id="with-placeholder"
                                    label={'Start Concediu'}
                                    name={'startConcediu'}
                                   
                                    margin="normal"
                                    type='date'
                                    value={this.props.startConcediu || ''}
                                    onChange={this.props.handleChange}
                                    InputLabelProps={{
                                        shrink:true
                                    }}
                                />
                            </Grid>
                
            
                    <Grid style={{textAlign:'center'}} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    id="with-placeholder"
                                    name={'sfarsitConcediu'}
                                    label={'Sfarsit Concediu'}
                                    margin="normal"
                                    type='date'
                                    value={this.props.sfarsitConcediu || ''}
                                    onChange={this.props.handleChange}
                                    InputLabelProps={{
                                        shrink:true
                                    }}
                                />
                </Grid>
                
                            
                    </Grid>        

                 <DialogActions className="pm-dialog-bottom-buttons">
                          
                          <Button  variant="outlined" onClick={this.props.scop === 'insert' ?this.props.insertConcediu : this.props.updateConcediu} className='pm-save-button'>
                                     Salveaza
                          </Button>

                         {this.props.scop === 'update' &&
                        
                          <Button  variant="outlined" onClick={this.props.stergeConcediu} className='pm-delete-button'>
                                     Sterge
                          </Button>
                       
                        }

                        {new LocalStorage().GetUserData().InfoUser.IsAdmin === 1 && this.props.scop === "update" &&
                            <Button  variant="outlined" onClick={this.props.aproba} className='pm-save-button'>
                            Aproba
                         </Button>
                        }
                     
                      </DialogActions>
                       
                   
                 </Dialog>
         </div>
        );
       }
}